module.exports = __webpack_public_path__ + "static/media/eshop.78bb3648.png";